export default __webpack_public_path__ + "static/media/Anderson Spada_.a65d032e.png";